import { render, staticRenderFns } from "./RecommendModal.vue?vue&type=template&id=bdac6114&"
import script from "./RecommendModal.vue?vue&type=script&lang=ts&"
export * from "./RecommendModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports